
import React from "react";
import CreateAttributeList, { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { TextIcon } from "../Icons/ComponentIcons";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";

import { AttributeCollection, getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { UpdateStyleFunction } from "../Stylebuilder";
import { SiteData } from "../Data/SiteData";
import ApplyToGlobalButton from "../Menus/ApplyToGlobalButton";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";




export default class WBText extends WBComponent {

    


    constructor(){
        super();
        this.typename = wBComponentTypeNames.text;
        this.displayName = "Text";
        this.dropList = defaultDropList;
        this.editList = ["textStyle",attributeTypes.alignContent, ...CreateAttributeList(true,true,true,true,false)];
        this.primaryEditAttributes = [
            "textStyle",
            attributeTypes.fontSize,
            attributeTypes.textAlign,
            "textVertical",
           ];

        this.contentEditable = true;
        this.icon = <TextIcon/>
        
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [

            new AttributeDefinition("textStyle","Text Style","",AttributeInputType.SelectField,
            [{label:"Paragraph 1",value:"vp-1"},{label:"Paragraph 2",value:"vp-2"},{label:"Paragraph 3",value:"vp-3"}])
        ];
    }

    
    RenderMenu({ editList, primaryList, layoutNode, screenSize, updateFunc, saveFunc, showScreenSize, siteData }: { updateFunc: UpdateStyleFunction; saveFunc: Function; editList: string[]; primaryList: string[]; layoutNode: AttributeCollection | null; screenSize: ScreenSize; showScreenSize?: boolean | undefined; siteData: SiteData; }): JSX.Element {
        
       
       
        const content = super.RenderMenu({editList,primaryList,layoutNode,screenSize,updateFunc,saveFunc,showScreenSize,siteData});


     
        if(!layoutNode)
        return content;
        
            const getCollection = (node: AttributeCollection) => {
              const hdrType = getNodeComponentAttributeValue(
                layoutNode,
                "textStyle",
                "vp-1"
              );

              let collection = siteData.siteStyling.paragraph3;
              switch (hdrType) {
                case "vp-1":
                  collection = siteData.siteStyling.paragraph1;
                  break;
                case "vp-2":
                  collection = siteData.siteStyling.paragraph2;
                  break;
                default:
                break;
              }

              return collection;
            };



        return <>
            {content}
            <br></br>
{screenSize===ScreenSize.Desktop&&
            <ApplyToGlobalButton siteData={siteData} layoutNode={layoutNode} getCollectionFunc={getCollection} />}
        </>

    }


    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps)
     {


        let textStyle = getNodeComponentAttributeValue(component,"textStyle","vp-1");
        
        return (


            <div  {...GetNodeDomAttributes("v-text "+textStyle,component,screenSize,isEditor)}  dangerouslySetInnerHTML={{ __html: component.content??"" }}>

            </div>
        )

    }

}